module.exports = __webpack_public_path__ + "video-cover-1x-615d2ea2399f94740116d2b0d508f28d.webp";